/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface TransactionReportRequest
 */
export interface TransactionReportRequest {
    /**
     * true to return completed transactions only, that ended between dateFrom-dateTo. False to include ongoing transactions
     * @type {boolean}
     * @memberof TransactionReportRequest
     */
    transactionsEndedWithinRangeOnly?: boolean;
    /**
     * Date from, inclusive. Date only, eg '2023-10-04'. Reports are run using AEST only (UTC+10, no daylight savings)
     * @type {string}
     * @memberof TransactionReportRequest
     */
    dateFrom?: string;
    /**
     * Date to, inclusive. Date only, eg '2023-10-04'. Reports are run using AEST only (UTC+10, no daylight savings)
     * @type {string}
     * @memberof TransactionReportRequest
     */
    dateTo?: string;
    /**
     * Report is run for all operational devices in this group. Prefer using DeviceGroupTags instead.
     * @type {string}
     * @memberof TransactionReportRequest
     */
    deviceGroupTag?: string;
    /**
     * Report is run for all operational devices in the intersection of all of these groups. Clients must provide at least one group they are directly assigned to, eg their org or a site. They may also provide groups they are not directly assigned to, eg ServiceModels
     * @type {Array<string>}
     * @memberof TransactionReportRequest
     */
    deviceGroupTags?: Array<string>;
}

/**
 * Check if a given object implements the TransactionReportRequest interface.
 */
export function instanceOfTransactionReportRequest(
    value: object,
): value is TransactionReportRequest {
    return true;
}

export function TransactionReportRequestFromJSON(
    json: any,
): TransactionReportRequest {
    return TransactionReportRequestFromJSONTyped(json, false);
}

export function TransactionReportRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): TransactionReportRequest {
    if (json == null) {
        return json;
    }
    return {
        transactionsEndedWithinRangeOnly:
            json["transactionsEndedWithinRangeOnly"] == null
                ? undefined
                : json["transactionsEndedWithinRangeOnly"],
        dateFrom: json["dateFrom"] == null ? undefined : json["dateFrom"],
        dateTo: json["dateTo"] == null ? undefined : json["dateTo"],
        deviceGroupTag:
            json["deviceGroupTag"] == null ? undefined : json["deviceGroupTag"],
        deviceGroupTags:
            json["deviceGroupTags"] == null
                ? undefined
                : json["deviceGroupTags"],
    };
}

export function TransactionReportRequestToJSON(
    value?: TransactionReportRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        transactionsEndedWithinRangeOnly:
            value["transactionsEndedWithinRangeOnly"],
        dateFrom: value["dateFrom"],
        dateTo: value["dateTo"],
        deviceGroupTag: value["deviceGroupTag"],
        deviceGroupTags: value["deviceGroupTags"],
    };
}
